export const ageMethod = "age nearest";
export const gateway = "https://qat-coughlin-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/coughlin";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJjb3VnaGxpbiIsIm5hbWUiOiJjb3VnaGxpbiIsImlhdCI6MTc4MDU4MjAwNSwiZXhwIjoxOTM4MzcwMDA1fQ.qk8qFwSawvVL0D4dAIQ22CP302tOpamo5Tuolu9eQYw";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-coughlin-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_coughlin",
			brands: [
				"qat-coughlin-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "coughlin",
			broker_formatted_name: "Coughlin Insurance Brokers",
			email: "crossroads@coughlin.com",
			environment: "qat",
			environment_id: "qat",
			formLabels: "hide",
			g4: "G-2QM64W4BM4",
			layout: "modern",
			logoPosition: "menu",
			map1: [
				"Unit 4 – 1170 Taylor Ave.",
				"Winnipeg",
				"MB",
				"R3M 3Z4",
			],
			map2: [
				"Unit 6 – 1570 Regent Ave. W.",
				"Winnipeg",
				"MB",
				"R2C 3B4",
			],
			map3: [
				"Unit 16-2188 McPhillips St.",
				"Winnipeg",
				"MB",
				"R2V 3C8",
			],
			map4: [
				"Unit 2-11 Vervain Dr.",
				"Rosser",
				"MB",
				"R0H 1E0",
			],
			"maps": {
				"map4": [
					"11 Vervain Dr.",
					"Rosser",
					"MB",
					"R0H 1E0",
				],
				"map3": [
					"2188 McPhillips St.",
					"Winnipeg",
					"MB",
					"R2V 3C8",
				],
				"map2": [
					"1570 Regent Ave. W.",
					"Winnipeg",
					"MB",
					"R2C 3B4",
				],
				"map1": [
					"1170 Taylor Ave.",
					"Winnipeg",
					"MB",
					"R3M 3Z4",
				],
			},
			menuEmail: "none",
			menuPhone: "button",
			phone: "204-953-4620",
			photo1: "show",
			photo2: "show",
			photo3: "show",
			photo4: "show",
			privacyLink: "https://www.coughlin.com/privacy-policy",
			progressMode: "steady",
			split: "0.5",
			tcLink: "",
			themeSwitcher: "hide",
			website: "https://www.coughlin.com",
			scope: "coughlin#branding#qat-coughlin-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-coughlin-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_coughlin",
			brands: [
				"qat-coughlin-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "coughlin",
			broker_formatted_name: "Coughlin Insurance Brokers",
			email: "crossroads@coughlin.com",
			environment: "qat",
			environment_id: "qat",
			formLabels: "hide",
			g4: "G-2QM64W4BM4",
			layout: "modern",
			logoPosition: "menu",
			map1: [
				"Unit 4 – 1170 Taylor Ave.",
				"Winnipeg",
				"MB",
				"R3M 3Z4",
			],
			map2: [
				"Unit 6 – 1570 Regent Ave. W.",
				"Winnipeg",
				"MB",
				"R2C 3B4",
			],
			map3: [
				"Unit 16-2188 McPhillips St.",
				"Winnipeg",
				"MB",
				"R2V 3C8",
			],
			map4: [
				"Unit 2-11 Vervain Dr.",
				"Rosser",
				"MB",
				"R0H 1E0",
			],
			"maps": {
				"map4": [
					"11 Vervain Dr.",
					"Rosser",
					"MB",
					"R0H 1E0",
				],
				"map3": [
					"2188 McPhillips St.",
					"Winnipeg",
					"MB",
					"R2V 3C8",
				],
				"map2": [
					"1570 Regent Ave. W.",
					"Winnipeg",
					"MB",
					"R2C 3B4",
				],
				"map1": [
					"1170 Taylor Ave.",
					"Winnipeg",
					"MB",
					"R3M 3Z4",
				],
			},
			menuEmail: "none",
			menuPhone: "button",
			phone: "204-953-4620",
			photo1: "show",
			photo2: "show",
			photo3: "show",
			photo4: "show",
			privacyLink: "https://www.coughlin.com/privacy-policy",
			progressMode: "steady",
			split: "0.5",
			tcLink: "",
			themeSwitcher: "hide",
			website: "https://www.coughlin.com",
			scope: "coughlin#branding#qat-coughlin-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-coughlin-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:06:45 GMT+0000 (Coordinated Universal Time)
